import { useState } from 'react';

import { useFormatMessage } from '../../../../intl/intl';
import LocalStorageService from '../../../../services/local-storage-service';

export function useComandaSetting() {
  const title = useFormatMessage({ id: 'settings.automaticComanda' });
  const description = useFormatMessage({
    id: 'settings.automaticComandaDescription',
  });

  const isActivatedStorage = LocalStorageService.getIsActivatedComanda();
  const [isActivated, setIsActivated] = useState(isActivatedStorage);

  const toggleActivated = (isChecked: boolean) => {
    const isChecklistActivated = LocalStorageService.getIsActivatedPrinterChecklist();
    if (!isChecklistActivated && isChecked) {
      return;
    }

    const value = isChecked ? '0' : '1';
    LocalStorageService.setIsActivatedComanda(value);
    setIsActivated(!isChecked);
  };

  return {
    title,
    description,
    isActivated,
    toggleActivated,
  };
}
